module.exports = __webpack_public_path__ + "static/media/ThumbnailStill18.51074e98.png";